import { render, staticRenderFns } from "./Nazioni.vue?vue&type=template&id=4a891a2e&"
import script from "./Nazioni.vue?vue&type=script&lang=js&"
export * from "./Nazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports